<template>
  <div class="cms">
    <template v-if="contents_type === 'block_contents'">
      <BlockContents
          :location_code="location_code"
          :view_type="view_type"
          @sendComplete="catchComplete"
      />
    </template>

    <template v-if="contents_type === 'other_page'">
      <OtherPage
        :view_type="view_type"
        @catchTitle="setTitle"
      />
    </template>

    <template v-if="contents_type === 'news'">
      <News :view_type="view_type" @catchTitle="setTitle" />
    </template>

  </div>
</template>

<script>
import "@/components/cms/css/cms-utility.scss";
import BlockContents from "@/components/cms/contents_type/BlockContents";
import OtherPage from "@/components/cms/contents_type/OtherPage.vue";
import News from "@/components/cms/contents_type/News.vue";

export default {
  name: "CMS",
  props: {
    contents_type: {
      type: String,
      default: "",
    },
    location_code: {
      type: String,
      default: null,
    },
    view_type: {
      type: String,
      default: null,
    },
    view_area: {
      type: String,
      default: null,
    },
    page_limit: {
      type: String,
      default: "",
    },
    item_list: {
      type: Array,
    },
    special_category: {
      type: String,
      default: null,
    }
  },
  components: {
    BlockContents,
    OtherPage,
    News,
  },

  data() {
    return {
    }
  },
  watch:{},
  computed: {},
  methods: {
    setTitle(title){
      this.$emit("catchTitle",title);
    },
    catchComplete(code) {
      this.$emit("sendComplete", code);
    }
  },

  created() {
  },
  mounted() {
  },
  updated() {
  },
  destroyed() {
  },

}
</script>

<style lang="scss">
</style>